import React from "react";
import { wordStyles } from "./wordStyles";

const getTextClass = (messageLength: number) => {
  if (messageLength < 6) return "entry-text-xxl";
  if (messageLength < 20) return "entry-text-xl";
  if (messageLength < 40) return "entry-text-l";
  if (messageLength < 70) return "entry-text-ll";
  if (messageLength < 130) return "entry-text-m";
  if (messageLength < 200) return "entry-text-s";
  return "entry-text-xs";
};

const styleWordInText = (text: string, styles: Record<string, string>) => {
  const words = text.split(" ");
  return words.map((word, index) => {
    const lastChar = word.slice(-1);
    const className =
      styles[
        lastChar === "?" ||
        lastChar === "!" ||
        lastChar === ":" ||
        lastChar === "." ||
        lastChar === ";" ||
        lastChar === ","
          ? word.slice(0, -1).toLowerCase()
          : word.toLowerCase()
      ] || "";
    return (
      <span key={index} className={className}>
        {word}
      </span>
    );
  });
};

// To be used later
const renderTextWithNewlines = (text: string) => {
  return text.split("\n").map((line, lineIndex) => (
    <React.Fragment key={lineIndex}>
      {styleWordInText(line, wordStyles).map((wordElement, wordIndex) => (
        <React.Fragment key={wordIndex}>
          {wordElement}
          {wordIndex !== line.split(" ").length - 1 && " "}
        </React.Fragment>
      ))}

      {/* Add <br /> except after last line */}
      {lineIndex !== text.split("\n").length - 1 && <br />}
    </React.Fragment>
  ));
};

export const entryRender = (
  divStyle: any,
  previousIndex: number | null,
  currentIndex: number,
  messages: string[],
  isAnimating: boolean,
  setPreviousIndex: (index: number | null) => void,
  setIsAnimating: (animating: boolean) => void,
) => {
  return (
    <div className="slide-container" style={divStyle}>
      {previousIndex !== null && (
        <div
          className={`${getTextClass(
            messages[previousIndex].length,
          )} slide-text ${isAnimating ? "slide-out" : ""}`}
          onAnimationEnd={() => setPreviousIndex(null)}
        >
          {styleWordInText(messages[previousIndex], wordStyles).map(
            (wordElement, index) => (
              <React.Fragment key={index}>
                {wordElement}
                {/* Add space if not last word */}
                {index !== messages[previousIndex].split(" ").length - 1 && " "}
              </React.Fragment>
            ),
          )}
        </div>
      )}
      <div
        className={`${getTextClass(messages[currentIndex].length)} slide-text ${
          isAnimating ? "slide-in" : ""
        }`}
        onAnimationEnd={() => setIsAnimating(false)}
      >
        {styleWordInText(messages[currentIndex], wordStyles).map(
          (wordElement, index) => (
            <React.Fragment key={index}>
              {wordElement}
              {/* Add space if not last word */}
              {index !== messages[currentIndex].split(" ").length - 1 && " "}
            </React.Fragment>
          ),
        )}
      </div>
    </div>
  );
};
